<template>
  <div class="import-tool">
    <Modal v-model="visible" title="导入" :mask-closable="false" width="670" class="my-modal import-tool-modal2">
      <Checkbox
            :indeterminate="indeterminate"
            v-model="checkAll"
            @on-change="handleCheckAll" style="padding-top: 20px;">全选</Checkbox>
      <div class="basic-info-box" v-for="(bean,i) in list" :key="i">
        <span class="title">{{bean.menuName}}</span>
        <CheckboxGroup v-model="bean.values" class="check-group" @on-change="checkAllGroupChange">
          <Checkbox :label="item.name" class="check" v-for="(item, index) in bean.list" :key="index" :disabled="!!item.isMust">
            <span class="label-name" :class="{'disabled':item.isMust}">{{ item.name }}</span>
            <Poptip
              trigger="hover"
              placement="top-start"
              :offset="-24"
              transfer-class-name="my-poptip"
              v-if="item.tips"
            >
              <span class="tip-icon">?</span>
              <div slot="content">
                <span>{{ item.tips }}</span>
              </div>
            </Poptip>
          </Checkbox>
        </CheckboxGroup>
      </div>

      
      <div class="ivu-modal-footer" slot="footer">
        <Button type="text"  @click="visible=false">取消</Button>
        <Button type="primary" @click="confirm" >确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible:false,
      indeterminate: false,
      checkAll: false,
      code:"",
      list:[],
    };
  },
  methods: {
    handleCheckAll (val) {
        if (this.indeterminate) {
            this.checkAll = false;
        } else {
            this.checkAll = val;
        }
        this.indeterminate = false;
        if (val) {
          this.list.forEach(item=>{
            item.list.forEach(item2=>{
              if(!item.values.includes(item2.name)){
                item.values.push(item2.name);
              }
          })
          });
        } else {
          this.list.forEach(item=>{
            item.values = []
            item.list.forEach(item2=>{
              if(item2.isMust==1 && item2.isExist==1){
                item.values.push(item2.name);
              }
            })
          });
        }
    },
    checkAllGroupChange () {
      let allLength = 0
      this.list.forEach(item=>{
        allLength = allLength + item.values.length
      })
      if (allLength === this.allData.length) {
            this.indeterminate = false;
            this.checkAll = true;
        } else if (allLength > 0) {
            this.indeterminate = true;
            this.checkAll = false;
        } else {
            this.indeterminate = false;
            this.checkAll = false;
        }
        
    },
    open(code){
      this.code = code;
      this.getExportData();
      this.visible = true;
    },
    // 获取选项数据
    getExportData() {
      this.$http({
        url: "/buz/importTask/exportFields",
        type: "GET",
        data:{
          code:this.code
        }
      }).then((res) => {
        res.data.forEach(item=>{
          item.values = [];
          item.list.forEach(item2=>{
            if(item2.isMust || item2.isExist){
              item.values.push(item2.name)
            }
          })
        })
        this.list = res.data;
        this.checkAll = false;
        this.indeterminate = false;
        this.allData = [];
        this.list.forEach(item=>{
            item.list.forEach(item2=>{
              this.allData.push(item2.name);
            })
          });
      })
    },
    // 确认提交
    confirm() {
      const data = [];
      this.list.forEach(item=>{
        item.list.forEach(item2=>{
          if(item.values.includes(item2.name)){
            data.push(item2.name);
          }
        })
      });
      // 去重
      const result = Array.from(new Set(data));
      this.$http({
        url: "/buz/importTask/importTemplateConfig",
        type: "POST",
        data:{
          code:this.code,
          fields:result
        }
      }).then((res) => {
        if(res.httpCode){
          this.$Message.success("设置成功");
          this.visible = false;
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
  .basic-info-box {
    margin-top: 20px;
    .title {
      display: block;
      font-size: 12px;
      color: #515C6F;
      font-weight: bold;
    }
    .check-group {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      
      .check {
        margin-top: 10px;
        width: 23.6%;
        span {
          margin-left: 4px;
        }
        & .disabled {
          color: #515C6F;
        }
        .tip-icon {
          width: 15px;
          height: 15px;
          border-radius: 15px;
          background: transparent;
          border: 1px solid #ccc;
          color: #ccc;
          display: inline-block;
          text-align: center;
          line-height: 15px;
          font-size: 12px;
          cursor: pointer;
          top: 50%;
        }
        .label-name {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
